import {
  useEffect,
  useState,
  type ImgHTMLAttributes,
  type ReactNode,
} from "react";

/**
 * Every uploaded or remote photo goes through here (course covers, lesson
 * thumbnails, school photos, upload previews), so a missing or broken file
 * never shows the browser's broken-image icon: it renders `fallback` instead
 * (a branded tile, or nothing so the surface behind shows). Avatars have the
 * same logic built into `Avatar`.
 */
export function Photo({
  src,
  fallback = null,
  alt = "",
  ...props
}: Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> & {
  src: string | null | undefined;
  fallback?: ReactNode;
}) {
  const [broken, setBroken] = useState(false);
  // A new src deserves a fresh attempt.
  useEffect(() => setBroken(false), [src]);
  if (!src || broken) return <>{fallback}</>;
  return (
    <img
      src={src}
      alt={alt}
      {...props}
      onError={(event) => {
        setBroken(true);
        props.onError?.(event);
      }}
    />
  );
}
